import React, { useEffect, useState } from "react";
import { TimerProps } from "./TimerProps";
import { State } from "./State";

const Timer: React.FC<TimerProps> = ({ time, reset, onTimeout, onReseted }) => {    
    const [state, setState] = useState<State>({
        time,
        seconds: time - Math.floor((time - 1) / 60) * 60 - 1,
        minuts: Math.floor((time - 1) / 60),
    });
    const [timerId, setTimerId] = useState<NodeJS.Timeout>()

    useEffect(() => {        
        const id = setTimeout(() => {
            if(state.time === 0) {
                onTimeout && onTimeout();
                return;
            }
            
            setState({
                time: state.time - 1,
                minuts: Math.floor((state.time - 1) / 60),
                seconds: state.time - Math.floor((state.time - 1) / 60) * 60 - 1
            });
        }, 1000);
        setTimerId(id);
    }, [state.time]);

    useEffect(() => {
        if(reset) {
            clearTimeout(timerId);
            //setTimerId(null);
            setState({
                time,
                seconds: time - Math.floor((time - 1) / 60) * 60 - 1,
                minuts: Math.floor((time - 1) / 60),
            });
            onReseted && onReseted();
        }
    }, [reset])

    return (
        <h2>{`${state.minuts < 10 ? `0${state.minuts}` : state.minuts}:${state.seconds < 10 ? `0${state.seconds}` : state.seconds}`}</h2>
    )
}

export default Timer;